"use client";

import { Box, Text } from "@mantine/core";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import classes from "./about-feature-tab.module.css";

interface AboutFeatureTabProps {
  title: string;
  isActive: boolean;
  onClick: () => void;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string };
}

export default function AboutFeatureTab({
  title,
  isActive,
  onClick,
  icon: Icon,
}: AboutFeatureTabProps) {
  return (
    <Box
      className={classes.tab}
      data-active={isActive ? "true" : undefined}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick()}
    >
      <Icon className={classes.icon} />
      <Text className={classes.title}>{title}</Text>
    </Box>
  );
}
